export enum DocumentStatus {
  None = 0,
  PendingApproval = 1,
  Approved = 2,
  Rejected = 3,
  Expired = 4,
  Delete = 5,
}

export const isDocumentStatusPendingApproval = (documentStatus: number | undefined): boolean => {
  return documentStatus === DocumentStatus.PendingApproval
}

export const isDocumentStatusExpired = (documentStatus: number | undefined): boolean => {
  return documentStatus === DocumentStatus.Expired
}

export const isDocumentStatusRejected = (documentStatus: number | undefined): boolean => {
  return documentStatus === DocumentStatus.Rejected
}

export const isDocumentStatusApproved = (documentStatus: number | undefined): boolean => {
  return documentStatus === DocumentStatus.Approved
}

export const isDocumentStatusDeleted = (documentStatus: number | undefined): boolean => {
  return documentStatus === DocumentStatus.Delete
}
